import mediaLazyLoad from '../utils/rbata.mediaLazyLoad';
import parallax from '../utils/rbata.parallax';

const storySlider = {
    sliderSelector:    '#js-storyslider__stories',
    $sliderContainer:  undefined,
    $sliderNavigation: undefined,
    slider:            null,
    buildSlider() {
        this.$sliderContainer  = $('#js-storyslider__stories');
        this.$sliderNavigation = this.$sliderContainer.next('nav');
        this.slider            = tns({
            container:            this.sliderSelector,
            mode:                 'gallery',
            items:                1,
            controls:             true,
            controlsContainer:    this.$sliderNavigation[0],
            nav:                  true,
            navPosition:          'bottom',
            arrowKeys:            true,
            speed:                1000,
            autoplay:             true,
            autoplayTimeout:      3000,
            autoplayButton:       false,
            autoplayButtonOutput: false,
            lazyload:             false,
            mouseDrag:            true,
            onInit:               () => {
                this.$sliderContainer.removeClass('cms-storyslider__stories--not-initialized');
                this.$sliderNavigation.removeClass('d-none');
                mediaLazyLoad.refreshLazyLoad();
                parallax.reloadParallaxPool();
            },
        });
    }
};

// DOM ready
$(() => {
    if (document.querySelector(storySlider.sliderSelector)) {
        storySlider.buildSlider();
    }
});
